export default __webpack_public_path__ + "static/media/step2regis.73446436.svg";